<ion-row>
  <ion-col>
    <ion-item class="transparent">
      <ion-label class="text-color-primary label-text-s ion-label-input">Contact Phone
        (optional)</ion-label>
    </ion-item>
  </ion-col>
</ion-row>

<ion-row>
  <ion-col [size]="12">
    <ion-item class="transparent">



      <ion-row class="phone-row full-w">
        <!-- Country selection -->
        <ion-col size="4">
          <!-- <ion-button id="country-trigger" expand="block" fill="outline" size="small"
            class="action-button-fill button-color-alternate">
            {{ selectedCountry?.text || 'Country' }}
          </ion-button>
          <ion-popover trigger="country-trigger" [dismissOnSelect]="true">
            <ng-template>
              <ion-list>
                <ion-item *ngFor="let item of phoneNumbers" (click)="selectCountry(item)">
                  {{ item.text }}
                </ion-item>
              </ion-list>
            </ng-template>
          </ion-popover> -->

          <!-- ionic-selectable-custom-wrapper -->
          <ion-item class="list-item transparent-bg item-noborder" *ngIf="loaded">
            <ionic-selectable #countrySelector [items]="phoneNumbers" [(ngModel)]="selectedCountryCode" name="bdCountry"
              #bdCountry="ngModel" ngDefaultControl itemValueField="code" itemTextField="text" [canSearch]="true"
              [shouldStoreItemValue]="true" [hasVirtualScroll]="true" (onChange)="selectCountryCode($event)"
              placeholder="country" class="text-left info-text-s" tappable>
              <ng-template ionicSelectableHeaderTemplate>
                <ion-toolbar>
                  <ion-buttons slot="end">
                    <ion-button (click)="countrySelector.close()"
                      class="as-text menu-button-size menu-button-size-right">
                      <div class="leplace-menu-icon">
                        <icon-wrapper [icon]="appIconsStandard.close" [custom]="false"></icon-wrapper>
                      </div>
                    </ion-button>
                  </ion-buttons>
                  <ion-title class="text-left">
                    <span class="title-s">
                      {{countrySelector.label}}
                    </span>
                  </ion-title>
                </ion-toolbar>
              </ng-template>
            </ionic-selectable>
          </ion-item>


        </ion-col>
        <!-- Phone number input -->
        <ion-col size="8" class="align-content">
          <ion-input type="tel" [(ngModel)]="tel" placeholder="+40 123 456 789" (ionInput)="onPhoneInput()">
          </ion-input>
        </ion-col>
      </ion-row>
    </ion-item>
  </ion-col>
</ion-row>